<template>
  <div class="nav-bar">
    <button
      v-for="(item, index) in NAV_ITEMS"
      :key="index"
      @click="go(item.path)"
      class="nav-item"
      :class="{ 'nav-active': route.path === item.path }"
    >
      <component v-if="item.icon" :is="item.icon" class="nav-icon" />
      <div>
        {{ $t(item.name) }}
      </div>
    </button>
  </div>
</template>

<script setup>
import IconBookForFate from '~icons/local-nav/book-for-fate'
import IconCourse from '~icons/local-nav/course'
import IconMall from '~icons/local-nav/mall'
import IconMy from '~icons/local-nav/my'

const router = useRouter()
const route = useRoute()

const NAV_ITEMS = [
  // {
  //   name: 'glbNav.home',
  //   path: '/fateReport',
  //   icon: IconBookForFate
  // },
  {
    name: 'glbNav.readings',
    path: '/fateReport',
    icon: IconBookForFate
  },
  // {
  //   name: 'glbNav.bookings',
  //   path: '/course',
  //   icon: IconCourse
  // },
  // {
  //   name: 'glbNav.shop',
  //   path: '/mall',
  //   icon: IconMall
  // },
  {
    name: 'glbNav.profile',
    path: '/my',
    icon: IconMy
  }
]

const go = (path) => {
  router.push(path)
}
</script>

<style lang="scss" scoped>
.nav-bar {
  display: flex;
  @include adapt($prop: flex-direction, $h5: row, $pc: column);
  @include adapt($prop: justify-content, $h5: space-around, $pc: flex-start);
  align-items: center;
  @include adapt($prop: gap, $h5: 0, $pc: 25);

  @include adapt($prop: width, $h5: 100%, $pc: 320);
  @include adapt($prop: height, $h5: 110, $pc: 100%);
  @include adapt($prop: padding, $h5: 10 0, $pc: 84 10);
  // @include adapt($prop: background, $h5: #0d1b3f, $pc: transparent);
  @include adapt($prop: background, $h5: #151c2b, $pc: transparent);

  .nav-item {
    display: flex;
    @include adapt($prop: flex-direction, $h5: column, $pc: row);
    justify-content: center;
    align-items: center;
    @include adapt($prop: gap, $h5: 1, $pc: 18);

    @include adapt($prop: width, $h5: 165, $pc: 210);
    @include adapt($prop: height, $h5: 90, $pc: 70);
    @include adapt($prop: border-radius, $h5: 20, $pc: 20);
    @include adapt($prop: font-size, $h5: 22, $pc: 22);
    border: none;
    color: #b3b3b3;
    @include adapt($prop: background, $h5: transparent, $pc: #50307e);
    cursor: pointer;

    &:hover {
      color: #fff;
    }

    &.nav-active {
      @include adapt($prop: background, $h5: #2b323f, $pc: #6f13c0);
      color: #c29a5c;
    }

    .nav-icon {
      @include adapt($prop: width, $h5: 52, $pc: 38);
      @include adapt($prop: height, $h5: 52, $pc: 38);
    }
  }
}
</style>
